class vehicalchassis {
    constructor(msg) {
        this.items =
        {
            id: 30001,
            name: "Custom Vehicle Make",
            type: "text",
            slideimg: "/doctorassistant/dia.jpg",
            options: [
                { id: 40012, text: "Submit", name: "Submit", type: "providecnic", desc: msg.desc, inputtype: "textinput",  },
            ],
            backtostart: false,
            text: [
                `<p>Please provide the Car chassis/Engine Number.</p> `
            ]
        }
    }

    getAllItems() {
        console.log(sessionStorage.getItem("car_information"));
        return this.items;
    }
}

export default vehicalchassis;
